import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'

import { whenPageIdle } from './whenPageIdle'

export const GAListener = () => {
	const location = useLocation()

	useEffect(() => {
		const page = location.pathname + location.search

		// GA is initialised once the page is idle; earlier pageviews are
		// queued and sent in order right after initialisation
		whenPageIdle(() => {
			ReactGA.send({ hitType: 'pageview', page })
		})
	}, [location])

	return null
}
